export default __webpack_public_path__ + "static/media/JTBC.06607b53.png";